module.exports = "https://cdn.dove.it/_next/static/public/assets/features/feature_2.bebebcafb82de56890d56a852e086f40.png";